import React, { ReactNode } from 'react';
import { isEmpty } from 'lodash';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableProps as MuiTableProps,
  TableRow,
} from '@mui/material';

const styles = {
  smallTable: {
    '& td, th': {
      padding: '13px 16px',
    },
  },
  table: {
    '& > tbody > tr, > thead > tr': {
      borderTop: '1px solid #c8ced3',
      borderBottom: '1px solid #c8ced3',
      '& td, th': {
        border: 0,
      },
    },
    '& > thead > tr:first-of-type': {
      borderWidth: 0,
    },
    '& > tbody > tr:first-of-type': {
      //borderTop: 0,
    },
    '& > tbody > tr': {
      backgroundColor: '#ffffff',
    },
    '& > thead > tr > th': {
      backgroundColor: 'white',
      fontWeight: 'bold',
      color: 'black',
    },
  },
  stripedTable: {
    '& > tbody > tr': {
      '&:nth-of-type(odd)': {
        backgroundColor: '#efefef',
      },
    },
  },
};
export type TableProps = {
  title?: string;
  emptyComponent?: ReactNode;
  striped?: boolean;
} & MuiTableProps;

const Table = ({ children, title, emptyComponent, sx, striped, ...props }: TableProps) => {
  const head = title ? (
    <TableHead>
      <TableRow>
        <TableCell colSpan={20}>{title}</TableCell>
      </TableRow>
    </TableHead>
  ) : null;

  const body = !isEmpty(children) ? (
    children
  ) : emptyComponent ? (
    <TableBody>
      <TableRow>
        <TableCell>{emptyComponent}</TableCell>
      </TableRow>
    </TableBody>
  ) : null;

  return (
    <MuiTable
      size="small"
      {...props}
      sx={[
        styles.table,
        striped ? styles.stripedTable : undefined,
        props.size === 'small' ? styles.smallTable : undefined,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {head}
      {body}
    </MuiTable>
  );
};

export { Table };
